.root {
    position: relative;
}

.content {
    top: 0;
    width: 100%;
    overflow: hidden;
    will-change: transform;
}

.inner {
    display: flex;
    will-change: transform;
}
